import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        container: {
            height: `calc(100vh - ${theme.spacing(12)})`,
            width: '100%',
            display: 'flex',
        },
        gridWrapper: {
            width: '100%',
        },
    }
})

export default useStyles
